import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full font-montserrat relative" }
const _hoisted_2 = { class: "relative w-full mb-[50px]" }
const _hoisted_3 = { class: "px-[10px] py-[20px] md:p-[20px] flex flex-col items-center relative bg-gray-50 min-h-screen top-[60px]" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-black font-bold py-[20px] text-center" }, "Home / List of mails", -1)
const _hoisted_5 = { class: "bg-white w-[100%] md:w-[95%] relative p-[10px]" }
const _hoisted_6 = { class: "text-black flex relative text-sm font-bold bg-white border border-gray-400 p-[10px] w-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "p-[5px] flex items-center w-[25px]" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "checkbox",
    name: "",
    id: ""
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "p-[5px] flex items-center w-[25px]" }, null, -1)
const _hoisted_9 = { class: "p-[5px] flex items-cenWiter relative" }
const _hoisted_10 = {
  type: "submit",
  for: "search",
  class: "absolute left-[10px] text-black cursor-pointer top-[10px] text-xl"
}
const _hoisted_11 = { class: "w-full relative" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", { class: "w-full relative" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-black flex relative text-sm font-bold bg-gray-50 border border-gray-400 p-[10px] w-full" }, [
    /*#__PURE__*/_createElementVNode("td", { class: "p-[5px] flex w-[50px]" }, "ID"),
    /*#__PURE__*/_createElementVNode("td", { class: "p-[5px] flex flex-1" }, "Object"),
    /*#__PURE__*/_createElementVNode("td", { class: "p-[5px] md:w-[calc(100%/4)] w-[calc(100%/3)] flex" }, "Sender"),
    /*#__PURE__*/_createElementVNode("td", { class: "p-[5px] md:w-[calc(100%/4)] w-[calc(100%/3)] flex" }, "Date")
  ])
], -1)
const _hoisted_13 = { class: "w-full relative" }
const _hoisted_14 = { class: "text-gray-600 flex relative text-sm bg-white border border-gray-400 p-[10px] w-full" }
const _hoisted_15 = { class: "items-center p-[5px] flex w-[50px]" }
const _hoisted_16 = { class: "items-center flex-1 p-[5px] flex" }
const _hoisted_17 = { class: "items-center md:w-[calc(100%/4)] w-[calc(100%/3)] p-[5px] flex overflow-x-auto flex-wrap" }
const _hoisted_18 = { class: "items-center md:w-[calc(100%/4)] w-[calc(100%/3)] p-[5px] flex overflow-x-auto flex-wrap" }
const _hoisted_19 = { class: "flex justify-center items-center mt-8 space-x-4" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  disabled: true,
  class: "bg-gray-200 text-gray-700 font-bold py-2 px-4 rounded cursor-pointer"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-gray-400 py-[50px] flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center font-bold text-sm" }, "© 2023 Cotonou Cadjehoun, Tous droits réservés.")
], -1)

import headerComponent from '../components/headerComponentAdmin.vue'
import { ref, onMounted } from 'vue';
import { searchOutline } from 'ionicons/icons';
import axios from 'axios';
import axiosInstance from '@/plugins/axios';

const pageSize = 8; 

export default /*#__PURE__*/_defineComponent({
  __name: 'ListOfMails',
  setup(__props) {

const pageTitle = ref('List of mails'); 
const mails = ref<any[]>([]);
const filteredMails = ref<any[]>([]);


const allMails = ref<any[]>([]); 

// ...

// ... (votre code existant)

const fetchAllMails = async () => {
    try {
        let allMails: any[] = [];
        let nextPage = '/mailings/';

        while (nextPage) {
            const response = await axiosInstance.get(nextPage);

            if (response.status === 200 || response.status === 201 || response.status === 204) {
                const { results, next } = response.data;
                allMails = allMails.concat(results);
                nextPage = next;
            } else {
                nextPage = null;
            }
        }
        return allMails;
    } catch (error) {
        console.error('Erreur lors du chargement des mails', error);
        return [];
    }
};

const handleSearch = async (event: any) => {
    const searchTerm = event.target.value.toLowerCase().trim();

    if (!searchTerm) {
        filteredMails.value = mails.value;
    } else {
        const allMails = await fetchAllMails();

        if (allMails.length > 0) {
            filteredMails.value = allMails.filter(mail => {
                return (
                    (mail.object && mail.object.toLowerCase().includes(searchTerm)) ||
                    (mail.content && mail.content.toLowerCase().includes(searchTerm))
                );
            });
        }
    }
};




onMounted(async () => {
  document.title = pageTitle.value;
  await fetchMails(); 
  try {
    const response = await axiosInstance.get('/mailings/');
    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const fetchedMails = response.data.results;
      // Sort fetched mails by date if needed
      fetchedMails.sort((a: any, b: any) => {
        return new Date(b.date).getTime() - new Date(a.date).getTime();
      });
      mails.value = fetchedMails;
      filteredMails.value = fetchedMails;
    }
  } catch (error) {
    console.error('Erreur lors du chargement des mails', error);
  }

});

const currentPage = ref(1);
const hasPreviousPage = ref(false);
const hasNextPage = ref(false);

const loadMails = async (page: number) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return;

    const response = await axiosInstance.get(`/mailings/?page=${page}&page_size=${pageSize}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const { results, previous, next } = response.data;
      filteredMails.value = results;
      hasPreviousPage.value = !!previous;
      hasNextPage.value = !!next;
    }
  } catch (error) {
    console.error('Erreur lors du chargement des mails', error);
  }
};


const loadPreviousPage = () => {
  if (hasPreviousPage.value) {
    currentPage.value--;
    loadMails(currentPage.value);
  }
};

const loadNextPage = () => {
  if (hasNextPage.value) {
    currentPage.value++;
    loadMails(currentPage.value);
  }
};

onMounted(() => {
  loadMails(currentPage.value);
});

const fetchMails = async () => {
    try {
        const response = await axiosInstance.get('/mailings/');
        if (response.status === 200 || response.status === 201 || response.status === 204) {
            const fetchedMails = response.data.results;
            fetchedMails.sort((a: any, b: any) => {
                return new Date(b.date).getTime() - new Date(a.date).getTime();
            });
            mails.value = fetchedMails;
            filteredMails.value = fetchedMails;
        }
    } catch (error) {
        console.error('Erreur lors du chargement des mails', error);
    }
};

const totalPageCount = ref(0);

const fetchTotalPageCount = async () => {
  try {
    const response = await axiosInstance.get('/mailings/');
    if (response.status === 200 || response.status === 201 || response.status === 204) {
      const totalMails = response.data.count;
      totalPageCount.value = Math.ceil(totalMails / pageSize);
    }
  } catch (error) {
    console.error('Erreur lors du chargement du nombre total de pages', error);
  }
};

onMounted(() => {
  fetchTotalPageCount();
})

const formatDateTimeInEnglish = (dateTimeString: string) => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  const formattedDateTime = new Date(dateTimeString).toLocaleString("fr-FR", options);
  return formattedDateTime;
}




return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_rowArticle = _resolveComponent("rowArticle")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(headerComponent),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("input", {
                  type: "search",
                  name: "search",
                  class: "border border-gray-700 pl-[30px] outline-none w-[250px] rounded-[5px] py-[5px] px-[10px]",
                  placeholder: "Search...",
                  id: "search",
                  onInput: _cache[0] || (_cache[0] = ($event: any) => (handleSearch($event)))
                }, null, 32),
                _createElementVNode("label", _hoisted_10, [
                  _createVNode(_component_ion_icon, { icon: _unref(searchOutline) }, null, 8, ["icon"])
                ])
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("tbody", _hoisted_13, [
              _createVNode(_component_rowArticle, { mails: filteredMails.value }, null, 8, ["mails"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMails.value, (mail) => {
                return (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                  _createElementVNode("td", _hoisted_15, _toDisplayString(mail.id), 1),
                  _createElementVNode("td", _hoisted_16, [
                    _createVNode(_component_router_link, {
                      to: { name: 'AddAnMailWith', params: { id: mail.id }},
                      class: "hover:text-black hover:underline duration-300"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(mail.object), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(mail.author_username), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(formatDateTimeInEnglish(mail.date)), 1)
                ]))
              }), 256))
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("button", {
              onClick: loadPreviousPage,
              disabled: !hasPreviousPage.value,
              class: _normalizeClass({ 'bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded': hasPreviousPage.value, 'bg-gray-300 text-gray-500 cursor-not-allowed py-2 px-4 rounded': !hasPreviousPage.value })
            }, " Previous ", 10, _hoisted_20),
            _createElementVNode("button", _hoisted_21, _toDisplayString(currentPage.value) + " / " + _toDisplayString(totalPageCount.value), 1),
            _createElementVNode("button", {
              onClick: loadNextPage,
              disabled: !hasNextPage.value,
              class: _normalizeClass({ 'bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded': hasNextPage.value, 'bg-gray-300 text-gray-500 cursor-not-allowed py-2 px-4 rounded': !hasNextPage.value })
            }, " Next ", 10, _hoisted_22)
          ])
        ])
      ])
    ]),
    _hoisted_23
  ]))
}
}

})